export const MAX_ATTACHMENT_BYTES = 20 * 1024 * 1024;
export const MAX_ATTACHMENT_LABEL = '20 МБ';

export const tooLargeAttachmentMessage = (fileRejections = []) => {
  const names = fileRejections
    .filter((rejection) => rejection.errors?.some((error) => error.code === 'file-too-large'))
    .map((rejection) => rejection.file?.name)
    .filter(Boolean);

  if (names.length === 0) return '';
  if (names.length === 1) {
    return `Файл «${names[0]}» больше ${MAX_ATTACHMENT_LABEL} и не был прикреплён`;
  }
  return `Файлы больше ${MAX_ATTACHMENT_LABEL} не были прикреплены: ${names.map((name) => `«${name}»`).join(', ')}`;
};
